export const en = {
  appName: 'FORTEXA',
  home: 'Home',
  reports: 'Reports',
  scans: 'Scans',
  settings: 'Settings',
  profile: 'Profile',
  login: 'Login',
  signup: 'Sign Up',
  register: 'Register',
  logout: 'Logout',
  upgrade: 'Upgrade',
  notifications: 'Notifications',
  language: 'Language',
  englishShort: 'EN',
  japanese: 'Japanese',
  japaneseNative: '日本語',
  toggleNavigationMenu: 'Toggle navigation menu',
  switchToJapanese: 'Switch to Japanese',
  switchToEnglish: 'Switch to English',
  fortexaLogoAlt: 'FORTEXA Logo',
  pro: 'PRO',
  field: 'Field',
  page: 'Page',
  show: 'Show',
  hide: 'Hide',
  analyzing: 'Analyzing...',
  securityDisclaimer: 'Your credentials are never stored and are handled securely in-memory during the scan',
  configureScan: 'Configure Scan',
  enterCredentials: 'Enter Credentials',
  verifyConfiguration: 'Verify Configuration',
  detectedLoginForm: 'Detected Login Form',
  availableFields: 'Available Fields:',
  submitButton: 'Submit Button',
  tip: 'Tip:',
  loginSuccessful: 'Login Successful!',
  credentialsVerified: 'Credentials verified. Session cookies captured.',
  loginFailed: 'Login Failed',
  couldNotAuthenticateProvidedCredentials: 'Could not authenticate with provided credentials',
  loginFieldNotFound: 'Could not locate the login field on the page. Try re-detecting the login form.',
  loginFieldFillFailed: 'Could not fill in one of the login fields. Try re-detecting the login form.',
  loginAnalysisFailed: 'The page indicates the login attempt was not successful.',
  loginUnexpectedError: 'An unexpected error occurred while testing the login.',
  loginPanelNotFound: 'Could not open the login form on this page. Check the address and try again.',
  loginSubmitNoEffect: 'Submitting the login form had no effect. Try selecting a different submit button above.',
  loginAuthUnconfirmed: 'The sign-in could not be confirmed.',
  loginNoSessionCookies: 'This site does not keep you signed in in a way the scan can reuse, so an authenticated scan is not possible for it.',
  loginUnconfirmed: 'Sign-in could not be confirmed',
  loginUnconfirmedExplain: 'The credentials were submitted, but we could not confirm the site treated them as signed in. You can continue — results may cover only publicly visible pages.',
  continueAnyway: 'Continue anyway',
  signedInMarkerLabel: 'Text shown only when signed in (optional)',
  signedInMarkerPlaceholder: 'e.g. Log out',
  signedInMarkerHint: 'A word or phrase that appears on your site only after signing in. This helps confirm the scan reaches your signed-in pages.',
  authCoverageConfirmed: 'Signed-in access confirmed for this scan.',
  authCoverageUnconfirmed: 'Signed-in access could not be confirmed. Results may cover only publicly visible pages.',
  authenticationVerified: 'Authentication Verified',
  readyToStartAuthenticatedSecurityScan: 'Ready to start authenticated security scan',
  targetLabel: 'Target:',
  loginUrlLabel: 'Login URL:',
  fieldsLabel: 'Fields:',
  credentialFields: 'credential field(s)',
  enter: 'Enter',
  selectFieldOption: '-- Select {label} --',
  targetUrlHelp: 'The main URL you want to analyze for vulnerabilities',
  loginPageUrlHelp: 'The URL of the login page (can be the same as your target)',
  detectionErrorLabel: 'Detection Error:',
  enterTargetAndLoginUrls: 'Enter the target URL to scan and the login page URL',
  authScanNoteTitle: 'Before You Start — Important Limitations',
  authScanNoteCaptcha: 'reCAPTCHA / CAPTCHA: If the login page requires a CAPTCHA check, automated login will fail. Temporarily disable CAPTCHA (or use a test/staging environment where it is not enforced) before running this scan.',
  authScanNoteMFA: 'Two-factor authentication (2FA / MFA): If the account requires a one-time code (SMS, email, or authenticator app) after entering the password, the tool cannot complete login. Use a test account with 2FA disabled.',
  authScanNoteOAuth: 'Social / SSO login (Google, Microsoft, etc.): Only standard username and password login forms are supported. If the application only offers "Sign in with Google" or similar buttons, the authenticated scan cannot be used.',
  authScanNoteWAF: 'IP blocking / bot detection: Some security systems may block automated requests. If the scan fails unexpectedly, the scan server\'s IP address may need to be whitelisted in the target environment.',
  scanComplete: 'Scan Complete',
  scanningInProgress: 'Scanning in Progress',
  securityScanCompletedReviewBelow: 'Security scan completed. Review the findings below.',
  runningAuthenticatedWebsiteScan: 'Running all security scanners on the authenticated website',
  finalizingResults: 'Finalizing results...',
  // Engine-agnostic scan progress (see frontend/src/utils/scanStatus.js).
  // Deliberately generic: clients must not learn which scanners are orchestrated.
  scanStepInProgress: 'Step {current} of {total} in progress...',
  scanningTarget: 'Scanning {target}...',
  vulnerabilityScan: 'Vulnerability Scan',
  vulnerabilityScanAuth: 'Vulnerability Scan (Authenticated)',
  threatIntelligence: 'Threat Intelligence',
  vulnerableHigh: 'Vulnerable (High)',
  vulnerableMedium: 'Vulnerable (Medium)',
  vulnerableLow: 'Vulnerable (Low)',
  runningSecurityTests: 'Running comprehensive security tests...',
  pageWillUpdateAutomatically: 'This page will automatically update when the scan completes.',
  urlsAndAlertsFound: 'Found {urls} URLs - {alerts} alerts so far',
  translatingReportToJapanese: 'Translating report to Japanese...',
  savingSchedule: 'Saving schedule...',
  scheduleCreatedSuccessfully: 'Schedule created successfully!',
  analysisComplete: 'Analysis complete!',
  scanWasStopped: 'Scan was stopped',
  stoppingScan: 'Stopping scan...',
  stoppingScanAndRestartingContainers: 'Stopping scan and restarting containers...',
  scanStoppedContainersRestartingForFreshEnvironment: 'Scan stopped - containers restarting for fresh environment',
  stopRequestSent: 'Stop request sent...',
  failedToStopScanWithReason: 'Failed to stop scan: {reason}',
  scanRequestAccepted: 'Scan request accepted...',
  initializingScan: 'Initializing scan...',
  analyzingTargetEnvironment: 'Analyzing target environment...',
  performingComprehensiveSiteAnalysis: 'Performing comprehensive site analysis...',
  aiGeneratedAnalysisSummary: 'AI-Generated Analysis Summary',
  generatingAiAnalysisWaitingForAllScanData: 'Generating AI analysis... (waiting for all scan data)',
  uploadProgress: 'Uploading {progress}%',
  scanning: 'Scanning...',
  pending: 'Pending',
  valid: 'Valid',
  unavailable: 'Unavailable',
  headersPresent: 'Headers Present',
  technologiesDetected: 'Technologies Detected',
  noTechnologiesDetected: 'No technologies detected',
  scanFailed: 'Scan Failed',
  passed: 'Passed',
  starting: 'Starting',
  notSet: 'Not Set',
  securityHeaders: 'Security Headers',
  performance: 'Performance',
  outOf100: 'out of 100',
  securityConfig: 'Security Config',
  malicious: 'Malicious',
  threatScore: 'threat score',
  sslCertificate: 'SSL Certificate',
  unknownIssuer: 'Unknown Issuer',
  techStack: 'Tech Stack',
  wafStatus: 'WAF Status',
  scoreOf100: 'Score: {score}/100',
  optimizationScore: 'Optimization Score',
  mxRecordsFound: 'MX Records Found',
  noMailServer: 'No Mail Server',
  domainRegistered: 'Domain Registered',
  enabled: 'Enabled',
  disabled: 'Disabled',
  preloaded: 'Preloaded',
  notPreloaded: 'Not Preloaded',
  clean: 'Clean',
  foundCount: '{count} Found',
  listsChecked: '{count} Lists Checked',
  green: 'Green',
  hosting: 'Hosting',
  notArchived: 'Not Archived',
  historicalSnapshots: 'Historical Snapshots',
  timeout: 'Timeout',
  notFound: 'Not Found',
  urlsInSitemap: 'URLs in Sitemap',
  complete: 'Complete',
  partial: 'Partial',
  missing: 'Missing',
  linksFound: 'Links Found',
  redirectHops: 'Redirect Hops',
  serversFound: 'Servers Found',
  dnssecStatus: 'DNSSEC Status',
  securityPolicy: 'Security Policy',
  redirectTo: 'Redirected to:',
  tryDifferentSubmitButton: 'If login fails, try selecting a different submit button from the dropdown above and test again.',
  selectLoginFieldsAndEnterCredentials: 'Select the login fields and enter your credentials',
  reviewConfigurationAndStartAuthenticatedSecurityScan: 'Review your configuration and start the authenticated security scan',
  publicWebsiteScan: 'Public Website Scan',
  authenticatedWebsiteScan: 'Authenticated Website Scan',
  chooseScanTypePrefix: 'Choose Your',
  chooseScanTypeHighlight: 'Scan Type',
  chooseScanTypeSubtitle: 'Select the type of security scan you want to perform',
  publicScanDescription: 'Comprehensive security analysis for publicly accessible websites. Includes deep vulnerability scanning, performance optimization checks, and security metadata analysis.',
  authScanDescription: 'Deep security analysis for login-protected areas. Automatically detects login interfaces, validates credentials, and performs in-depth scans on authenticated areas.',
  comprehensiveVulnerabilityScan: 'Comprehensive Vulnerability Scan',
  sitePerformanceAnalysis: 'Site Performance Analysis',
  securityHeaderAnalysis: 'Security Header Analysis',
  websiteHealthCheck: 'Website Health Check',
  noLoginRequired: 'No Login Required',
  autoDetectLoginForms: 'Auto-Detect Login Forms',
  credentialValidation: 'Credential Validation',
  inDepthAuthenticatedScan: 'In-Depth Authenticated Scan',
  cookieSessionManagement: 'Cookie-Based Session Management',
  serverSideCredentialHandling: 'Server-Side Credential Handling',
  scheduleScan: 'Schedule Scan',
  startPublicScan: 'Start Public Scan',
  startAuthenticatedScan: 'Start Authenticated Scan',
  credentialsSecurityNote: 'Your credentials are never stored and are handled securely in-memory during the scan',
  heroTitle: 'Visualizing Security Risks Across Websites and Web Applications',
  scanNotice: 'Scan running in the background — you will be notified when complete. Safe to close this tab, refresh the page, or turn off your device.',
  enterUrlToStart: 'Enter a URL to start',
  urlExample: 'https://example.com',
  analyzeUrl: 'Analyze URL',
  stopScan: 'Stop Scan',
  resumingScan: 'Resuming scan...',
  saveScheduledScan: 'Save Scheduled Scan',
  schedulingModeActive: 'Scheduling Mode Active',
  settingUpPublicScan: 'Setting up a public scan for {date} at {time}',
  settingUpAuthScan: 'Setting up an authenticated scan for {date} at {time}',
  combinedScanReport: 'Combined Scan Report',
  combinedScanReportTarget: ' for {target}',
  websiteScreenshot: 'Website Screenshot',
  backToProfile: 'Back to Profile',
  historicalScan: 'Historical Scan',
  scannedOn: 'Scanned on',
  loadingProfile: 'Loading profile...',
  sessionExpiredLoginAgain: 'Session expired. Please log in again.',
  failedFetchProfile: 'Failed to fetch profile',
  failedLoadProfile: 'Failed to load profile. Check console for details.',
  failedUpdateProfile: 'Failed to update profile',
  profileUpdated: 'Profile updated successfully!',
  myProfile: 'My Profile',
  accountInformation: 'Account Information',
  editProfile: 'Edit Profile',
  save: 'Save',
  cancel: 'Cancel',
  name: 'Name',
  email: 'Email',
  password: 'Password',
  bio: 'Bio',
  accountType: 'Account Type',
  memberSince: 'Member Since',
  lastLogin: 'Last Login',
  noBioAdded: 'No bio added yet',
  bioPlaceholder: 'Tell us about yourself (max 500 characters)',
  statistics: 'Statistics',
  totalScans: 'Total Scans',
  noPlanScanLimit: 'No plan',
  planScanLimitLabel: 'Plan Scan Limit',
  extraScansRemainingLabel: 'Extra Scans Remaining',
  extraScansExpireOn: 'Expires {date}',
  topUpSectionTitle: 'Need More Scans?',
  topUpSectionDescription: 'Used up your monthly allowance? Add one-off scans on top of your current plan. Extra scans are used only after your monthly allowance is exhausted.',
  planLimitExhaustedHint: "You've used all scans included in your plan this month. Purchase extra scans below to keep scanning.",
  buyExtraScans: 'Buy Extra Scans',
  recentScans: 'Recent Scans',
  noScansYet: 'No scans yet. Start by analyzing a URL!',
  scheduledScan: 'Scheduled Scan',
  clickViewScanResults: 'Click to view scan results (Status: {status})',
  choosePlan: 'Choose Your Plan',
  selectPlan: 'Select Plan',
  startingCheckout: 'Redirecting to checkout...',
  checkoutFailed: 'Failed to start checkout. Please try again.',
  billingUnavailable: 'Billing is temporarily unavailable. Please try again later or contact support.',
  paymentProcessing: 'Payment received. Activating your plan...',
  checkingPlanStatus: 'Checking plan status...',
  refreshPlanStatus: 'Refresh Status',
  paymentPendingActivation: 'Payment succeeded, but activation is still syncing. Please refresh in a few moments.',
  paymentSuccess: 'Payment successful! Your plan has been activated.',
  paymentCancelled: 'Payment was cancelled. No charges were made.',
  currentPlanTitle: 'Your Plan',
  planStatus: 'Status',
  planStatusActive: 'Active',
  planStatusPastDue: 'Payment Past Due',
  scansUsedLabel: 'Scans Used This Month',
  seatsUsedLabel: 'Seats Used',
  teamManagement: 'Team Management',
  emailAddress: 'Email Address',
  sendInvite: 'Send Invite',
  activeMembers: 'Active Members',
  pendingInvites: 'Pending Invites',
  revoke: 'Revoke',
  revokeInvite: 'Revoke Invite',
  inviteSentSuccess: 'Invite sent to {email}',
  inviteEmailFailed: 'Invite created but email delivery failed. Share this link manually: {link}',
  inviteRevokeFailed: 'Failed to revoke invite',
  oneTimeScansRemaining: 'Scans Remaining',
  planExpiresLabel: 'Plan Expires',
  cancelSubscriptionNote: 'Your plan remains active until the end of the billing period.',
  subscriptionCancelled: 'Subscription cancelled. Access continues until the end of the billing period.',
  cancelProSubscription: 'Cancel Pro Subscription',
  downgradeConfirmMessage: "Are you sure you want to cancel your subscription? You'll keep access until the end of the current billing period.",
  cancelSubscription: 'Cancel Subscription',
  keepPro: 'Keep Plan',
  billingMonthly: 'Monthly',
  billingAnnual: 'Annual',
  billingOneTime: 'One-Time Trial',
  discount17Percent: '17% OFF',
  mostPopular: 'Most Popular',
  planFree: 'Free',
  planLight: 'Light Plan',
  planBasic: 'Basic Plan',
  planPro: 'Pro Plan',
  planTrial1: 'Trial 1',
  planTrial2: 'Trial 2',
  periodMonth: '/month',
  periodYear: '/year',
  priceExcludingTax: 'Excluding Tax',
  priceIncludingTaxAmount: 'Including Tax: {amount}',
  planAccounts: '{count} account{plural}',
  planScansPerMonth: '{count} scans/month',
  planScansForTarget: '{count} scan{plural} for 1 target',
  trial1ScansAndDevice: '1 device / 1 scan',
  trial2ScansAndDevice: '1 device / 2 scans',
  validityPeriod: 'Validity Period: 90 days',
  severityAllLevels: 'All severity levels',
  severityCriticalHighOnly: 'High + Medium only',
  failedCancelSubscription: 'Failed to cancel subscription',
  failedSendInvite: 'Failed to send invite',
  loginTitle: 'Login',
  loggingIn: 'Logging in...',
  loginWithGoogle: 'Login with Google',
  googleLoginSuccessful: 'Google login successful! Redirecting...',
  googleLoginFailed: 'Google Login failed. Please try again.',
  googleLoginFailedShort: 'Google Login Failed',
  inviteEmailMismatch: 'This invitation was sent to another email address. Please sign in using the invited Google account or the invited email.',
  loginFailedLater: 'Login failed. Please try again later.',
  newUser: 'New user?',
  registerNow: 'Register now',
  forgotPassword: 'Forgot Password?',
  registerTitle: 'Register',
  registering: 'Registering...',
  signUpWithGoogle: 'Sign up with Google',
  googleSignupSuccessful: 'Google sign up successful! Redirecting...',
  googleSignupFailed: 'Google sign up failed. Please try again.',
  googleSignupFailedShort: 'Google Sign Up Failed',
  registrationFailedLater: 'Registration failed. Please try again later.',
  haveAccount: 'Have an account already?',
  logIn: 'Log in',
  or: 'OR',
  forgotPasswordDescription: "Enter your email address and we'll send you a link to reset your password.",
  sending: 'Sending...',
  sendResetLink: 'Send Reset Link',
  rememberPassword: 'Remember your password?',
  resetPassword: 'Reset Password',
  resetPasswordDescription: 'Enter your new password below.',
  newPassword: 'New Password',
  confirmNewPassword: 'Confirm New Password',
  resetting: 'Resetting...',
  invalidResetLink: 'Invalid reset link',
  passwordsDoNotMatch: 'Passwords do not match',
  passwordMinLength: 'Password must be at least 8 characters long',
  genericErrorLater: 'An error occurred. Please try again later.',
  verifyEmail: 'Verify Your Email',
  otpSentTo: "We've sent a 6-digit code to",
  enterOtp: 'Enter 6-digit code',
  verifying: 'Verifying...',
  verify: 'Verify',
  resendCode: 'Resend Code',
  otpVerificationSuccess: 'Verification successful! Welcome!',
  verificationFailed: 'Verification failed. Please try again.',
  otpSentSuccess: 'OTP sent successfully. Please check your email.',
  resendOtpFailed: 'Failed to resend OTP. Please try again.',
  wrongEmail: 'Wrong email?',
  goBackToLogin: 'Go back to login',
  scheduledScans: 'Scheduled Scans',
  failedFetchSchedules: 'Failed to fetch schedules',
  failedDeleteSchedule: 'Failed to delete schedule',
  failedTriggerScan: 'Failed to trigger scan',
  scheduledScansSubtitle: 'Manage your one-time and recurring security scans',
  newSchedule: '+ New Schedule',
  activeSchedules: 'Active Schedules',
  loadingSchedules: 'Loading schedules...',
  noScheduledScans: 'No Scheduled Scans',
  noScheduledScansDescription: 'Create your first scheduled scan to automatically run security tests on your targets.',
  goDashboardSchedule: 'Go to Profile to Schedule',
  fetched: 'Fetched',
  public: 'Public',
  auth: 'Auth',
  recurring: 'Recurring',
  oneTime: 'One-Time',
  recurrence: 'Recurrence',
  nextRun: 'Next Run',
  lastRun: 'Last Run',
  lastFailure: 'Last failure: {reason}',
  runNow: 'Run Now',
  edit: 'Edit',
  delete: 'Delete',
  deleteSchedulePrompt: 'Delete this schedule?',
  yesDelete: 'Yes, Delete',
  scheduled: 'Scheduled',
  running: 'Running',
  completed: 'Completed',
  failed: 'Failed',
  dayAtTime: 'Day{plural} {days} at {time}',
  notAvailable: 'N/A',
  scheduleAScan: 'Schedule a Scan',
  editSchedule: 'Edit Schedule',
  targetUrlReadOnly: 'Target URL (Read Only)',
  scheduleMode: 'Schedule Mode',
  pickDateTime: 'Pick date & time',
  autoRepeat: 'Auto-repeat',
  date: 'Date',
  time: 'Time',
  selectDate: 'Select Date',
  today: 'Today',
  selectedTime: 'Selected: {time}',
  timezoneNote: 'Times are in {timezone}',
  frequency: 'Frequency',
  twiceMonthly: 'twice monthly',
  custom: 'custom',
  monthly: 'monthly',
  daysOfMonth: 'Day(s) of Month',
  executionTime: 'Execution Time',
  processing: 'Processing...',
  updateSchedule: 'Update Schedule',
  continueToConfig: 'Continue to Config',
  pleaseLoginSchedule: 'Please log in to schedule scans',
  pleaseSelectDateTime: 'Please select a date and time',
  invalidDateTime: 'Invalid date/time',
  scheduledTimeFuture: 'Scheduled time must be in the future',
  scheduledTimeWithinMonth: 'Scheduled time must be within 1 month from now',
  pleaseSelectDay: 'Please select at least one day',
  configSavedRedirecting: 'Configuration saved! Redirecting...',
  scheduleUpdated: 'Schedule updated!',
  scanScheduledSuccess: 'Scan scheduled successfully!',
  failedSaveSchedule: 'Failed to save schedule',
  errInvalidTimezone: 'Your device reported a time zone we do not recognise. Please try again.',
  errNoUpcomingOccurrence: 'That recurrence has no upcoming date. Please choose different days.',
  targetUrl: 'target URL',
  dismiss: 'Dismiss',
  configure: 'Configure',
  credentials: 'Credentials',
  verifyStep: 'Verify',
  results: 'Results',
  targetWebsiteUrl: 'Target Website URL',
  loginPageUrl: 'Login Page URL',
  detectLoginFields: 'Detect Login Fields',
  detecting: 'Detecting...',
  back: 'Back',
  continue: 'Continue',
  testLogin: 'Test Login',
  testingLogin: 'Testing Login...',
  pleaseFillCredentials: 'Please fill in all credential fields',
  couldNotAnalyzeLogin: 'Could not analyze the login page',
  noLoginFormsDetected: 'No login forms detected on this page.',
  loginTestFailed: 'Login test failed',
  sessionExpiredTestAgain: 'Session expired. Please test login again.',
  failedStartScan: 'Failed to start scan',
  severity: 'Severity',
  vulnerabilityAnalysisResults: 'Vulnerability Analysis Results',
  alertTypes: 'Alert Types',
  totalOccurrences: 'Total Occurrences',
  jsonReport: 'JSON Report',
  pdfReport: 'PDF Report',
  downloading: 'Downloading...',
  generatingLang: 'Generating {lang}...',
  englishPdf: 'English PDF',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  informational: 'Informational',
  occurrence: 'occurrence',
  occurrences: 'occurrences',
  description: 'Description',
  solution: 'Solution',
  affectedUrls: 'Affected URLs ({count} shown{more})',
  moreInFullReport: ', more in full report',
  vulnerabilityAffectsUrls: 'This vulnerability affects {count} URLs total. Download the full report to see all affected URLs.',
  requestResponseEvidence: 'Request / Response Evidence',
  evidenceRequest: 'Request',
  evidenceResponse: 'Response',
  loadingEvidence: 'Loading request/response data…',
  noEvidenceCaptured: 'No raw request/response was captured for this finding.',
  showAllEvidence: 'Show all {count} request/response pairs',
  showLessEvidence: 'Show fewer',
  evidenceFullInJson: 'Full request/response for every occurrence is available in the JSON report.',
  noVulnerabilities: 'No security vulnerabilities detected. Great job!',
  failedDownloadDetailedReport: 'Failed to download detailed report',
  failedDownloadPdfReport: 'Failed to download PDF report: {message}',
  geminiKeyExhausted: 'AI service temporarily unavailable. Please try again later.',
  englishPdfOnly: 'English PDF must contain English only',
  // PDF download outcomes — resolved from structured fields, never from a
  // backend-supplied English `error` string.
  pdfRateLimited: 'Too many requests just now. Please wait a moment and try again.',
  pdfGenerationFailed: 'The report could not be generated. Please try again.',
  pdfGenerationTimedOut: 'The report is taking longer than expected. Please try again.',
  pdfJobExpired: 'This report is no longer available. Please generate it again.',
  pdfScanIncomplete: 'This scan has no report available yet.',
  // Scan failure states
  scanFailedTitle: 'Scan could not be completed',
  scanFailedVulnerability: 'The security assessment could not finish, so no report was produced. This scan was not counted against your plan — please run it again.',
  scanFailedGeneric: 'This scan did not complete successfully. It was not counted against your plan — please run it again.',
  rescanNow: 'Run the scan again',
  scanRateLimited: 'Please wait a moment before starting another scan.',
  planLimitReached: 'Your plan limit has been reached. Visit your Profile page to upgrade.',
  organizationRequired: 'An active plan is required to run a scan.',
  pdfDownloadFailed: 'PDF download failed',
  downloadScanReports: 'Download Scan Reports',
  downloadCompleteSecurityResults: 'Download your complete security scan results in your preferred format',
  generating: 'Generating...',
  downloadPdfReport: 'Download PDF Report',
  englishVersion: 'English Version',
  japaneseVersion: 'Japanese Version',
  downloadJsonData: 'Download JSON Data',
  initializingEnglishPdf: 'Initializing English PDF...',
  initializingJapanesePdf: 'Initializing Japanese PDF...',
  formattingScanData: 'Formatting scan data...',
  formattingAiAnalysis: 'Formatting AI analysis...',
  renderingPdfDocument: 'Rendering PDF document...',
  finalizing: 'Finalizing...',
  translatingToJapanese: 'Preparing Japanese report...',
  downloadComplete: 'Download complete!',
  failedDownloadReportTryAgain: 'Failed to download report. Please try again.',
  pdfProgressNote: 'PDF generation formats the report and may take up to 2 minutes.',
  downloadNote: 'PDF: Professional bilingual report (EN + JA) | JSON: Raw data for analysis',
  viewSiteHealthAnalysis: 'View Site Health Analysis ({count} components analyzed)',
  viewUrlscanAnalysis: 'View Threat Intelligence Analysis',
  urlscanSecurityVerdict: 'Security Verdict',
  urlscanOverall: 'Overall',
  urlscanThreatScore: 'Threat Score',
  urlscanUrlscanScore: 'Reputation Score',
  urlscanEngineDetections: 'Engine Detections',
  urlscanCommunityScore: 'Community Score',
  urlscanMalicious: 'MALICIOUS',
  urlscanClean: 'CLEAN',
  urlscanMaliciousCount: '{count} malicious',
  urlscanPageInformation: 'Page Information',
  urlscanDomain: 'Domain',
  urlscanIpAddress: 'IP Address',
  urlscanCountry: 'Country',
  urlscanServer: 'Server',
  urlscanTlsIssuer: 'TLS Issuer',
  urlscanTlsValidDays: 'TLS Valid Days',
  urlscanNetworkStatistics: 'Network Statistics',
  urlscanHttpRequests: 'HTTP Requests',
  urlscanUniqueIps: 'Unique IPs',
  urlscanUniqueCountries: 'Unique Countries',
  urlscanDataTransferred: 'Data Transferred',
  urlscanAllDataShown: 'All threat intelligence and page analysis data from this scan is displayed above.',
  mozillaObservatorySecurityConfiguration: 'Security Configuration',
  obsSecurityGrade: 'Security Grade',
  obsScore: 'Score',
  obsTestsPassed: 'Tests Passed',
  obsTestsFailed: 'Tests Failed',
  obsGradeA: 'Excellent security configuration',
  obsGradeB: 'Good configuration with minor gaps',
  obsGradeC: 'Moderate risk — several headers missing',
  obsGradeD: 'Poor configuration — significant exposure',
  obsGradeF: 'Critical — most security headers absent',
  obsRecommendedFixes: 'Recommended Security Header Fixes',
  obsCspDesc: 'prevents cross-site scripting (XSS) and data injection attacks',
  obsHstsDesc: 'forces HTTPS and prevents SSL-stripping attacks',
  obsXctoDesc: 'blocks MIME-type sniffing that can enable drive-by downloads',
  obsXfoDesc: 'prevents clickjacking by blocking framing from untrusted origins',
  obsRpDesc: 'limits referrer data leakage to third-party sites',
  obsPpDesc: 'restricts access to browser features (camera, microphone, geolocation)',
  obsNoData: 'Security header analysis data not available for this URL.',
  sslCertificateDetails: 'SSL Certificate Details',
  subject: 'Subject',
  issuer: 'Issuer',
  validFrom: 'Valid From',
  validTo: 'Valid To',
  serial: 'Serial',
  validation: 'Validation',
  dnsRecords: 'DNS Records',
  mxRecords: 'MX Records',
  txtRecords: 'TXT Records',
  found: 'found',
  technologyStack: 'Technology Stack',
  openPorts: 'Open Ports',
  open: 'Open',
  noOpenPorts: 'No common ports detected as open',
  closedFilteredPorts: 'Closed/Filtered ports ({count})',
  cookies: 'Cookies',
  headerCookies: 'Header Cookies',
  clientCookies: 'Client Cookies',
  viewHeaderCookies: 'View header cookies ({count})',
  viewClientCookies: 'View client cookies ({count})',
  whoisInformation: 'WHOIS Information',
  registrar: 'Registrar',
  created: 'Created',
  expires: 'Expires',
  updated: 'Updated',
  nameservers: 'Nameservers',
  domainStatus: 'Domain Status',
  mailConfiguration: 'Mail Configuration',
  mailServices: 'Mail Services',
  noneDetected: 'None detected',
  mailTxtRecords: 'Mail TXT records ({count})',
  tlsSecurityAnalysis: 'TLS Security Analysis',
  grade: 'Grade',
  score: 'Score',
  host: 'Host',
  socialMediaTags: 'Social Media Tags',
  twitterCard: 'Twitter Card',
  themeColor: 'Theme Color',
  redirectChain: 'Redirect Chain',
  webArchiveHistory: 'Web Archive History',
  totalSnapshots: 'Total Snapshots',
  available: 'Available',
  firstSnapshot: 'First Snapshot',
  lastSnapshot: 'Last Snapshot',
  carbonFootprint: 'Carbon Footprint',
  greenHosting: 'Green Hosting',
  yes: 'Yes',
  no: 'No',
  co2PerVisit: 'CO2 per visit',
  cleanerThan: 'Cleaner than',
  ofSites: 'of sites',
  robotsTxt: 'Robots.txt',
  noRobotsTxt: 'No robots.txt file found',
  sitemap: 'Sitemap',
  noSitemap: 'No sitemap found',
  urls: 'URLs',
  viewSitemaps: 'View sitemaps ({count})',
  viewUrls: 'View URLs ({count})',
  dnsServer: 'DNS Server',
  server: 'Server',
  provider: 'Provider',
  country: 'Country',
  status: 'Status',
  enabledValid: 'Enabled & Valid',
  notEnabled: 'Not Enabled',
  algorithm: 'Algorithm',
  keyTag: 'Key Tag',
  digestType: 'Digest Type',
  dsRecords: 'DS Records',
  dnskeyRecords: 'DNSKEY Records',
  websiteRanking: 'Website Ranking',
  top100: 'Top 100',
  top1k: 'Top 1K',
  top10k: 'Top 10K',
  top100k: 'Top 100K',
  top1m: 'Top 1M',
  trafficRank: 'Traffic Rank',
  notGlobalTop1m: 'Not found in the global top 1M domains list.',
  httpStatus: 'HTTP Status',
  responseTime: 'Response Time',
  traceRoute: 'Trace Route',
  allHopsUnreachable: 'All {count} hops were unreachable (likely blocked by a firewall or CDN).',
  unreachableHopsHidden: '{count} unreachable hop{plural} hidden',
  traceRouteDataAvailable: 'Trace route data available',
  ipAddress: 'IP Address',
  ip: 'IP',
  version: 'Version',
  location: 'Location',
  isp: 'ISP',
  organization: 'Organization',
  firewall: 'Firewall',
  tlsGrade: 'TLS Grade',
  quality: 'Quality',
  mailConfig: 'Mail Config',
  securityBlacklist: 'Security Blacklist',
  carbon: 'Carbon',
  archives: 'Archives',
  socialTags: 'Social Tags',
  links: 'Links',
  redirects: 'Redirects',
  rank: 'Rank',
  alerts: 'Alerts',
  alertsCount: '{count} Alerts',
  alertsCountPartial: '{count} Alerts (Partial)',
  crawlerRules: 'Crawler Rules',
  globalRank: 'Global Rank',
  qualityMetrics: 'Quality Metrics',
  overall: 'Overall',
  accessibility: 'Accessibility',
  bestPractices: 'Best Practices',
  seo: 'SEO',
  pwa: 'PWA',
  loadingExperience: 'Loading Experience',
  qualityDataAvailable: 'Quality data available',
  // WebCheck detail labels
  subjectAltNames: 'Subject Alt Names ({count})',
  sha256Label: 'SHA-256',
  httpHeaders: 'HTTP Headers',
  firewallWafDetection: 'Firewall / WAF Detection',
  wafDetected: 'WAF Detected',
  notDetected: 'Not Detected',
  wafNameLabel: 'Name',
  confidence: 'Confidence',
  hstsFullTitle: 'HSTS (HTTP Strict Transport Security)',
  maxAge: 'Max-Age',
  includeSubdomains: 'Include Subdomains',
  seconds: 'seconds',
  days: 'days',
  securityTxtTitle: 'Security.txt',
  noSecurityTxtFound: 'No security.txt file found',
  contactLabel: 'Contact',
  languagesLabel: 'Languages',
  canonicalLabel: 'Canonical',
  viewFullSecurityTxt: 'View full security.txt',
  blockLists: 'Block Lists',
  listedOnBlocklists: 'Listed on {count} blocklist(s)',
  notListedOnBlocklists: 'Not listed on any blocklists',
  cleanOnLists: 'Clean on {count} lists',
  blockListDataAvailable: 'Block list data available',
  blockedLabel: 'Blocked',
  linkedPages: 'Linked Pages',
  internalLinks: 'Internal Links',
  externalLinks: 'External Links',
  viewInternalLinks: 'View internal links ({count})',
  viewExternalLinks: 'View external links ({count})',
  urlLabel: 'URL',
  dnsServerInfoAvailable: 'DNS server information available',
  dnssecTitle: 'DNSSEC',
  hopLabel: 'Hop',
  rttLabel: 'RTT',
  ogTitleLabel: 'OG Title',
  ogDescriptionLabel: 'OG Description',
  ogImageLabel: 'OG Image',
  serverN: 'Server {n}',
  priorityLabel: 'priority',
  // ZapReportEnhanced labels
  translatingVulnerabilityData: 'Translating vulnerability data to Japanese...',


  // ── Admin Dashboard ──────────────────────────────────────────────────────────
  adminPanel: 'Admin Panel',
  adminDashboard: 'Admin Dashboard',
  adminUsers: 'Users',
  adminOrganizations: 'Organizations',
  adminScans: 'Scans',
  adminSystemHealth: 'System Health',
  adminOverview: 'Overview',
  adminTotalUsers: 'Total Users',
  adminVerifiedUsers: 'Verified Users',
  adminActiveOrgs: 'Active Orgs',
  adminTotalOrgs: 'Total Organizations',
  adminRunningScans: 'Running Scans',
  adminTotalScans: 'Total Scans (All-Time)',
  adminRecentUsers: 'Recent Registrations',
  adminPlanDistribution: 'Plan Distribution',
  adminSearch: 'Search...',
  adminFilter: 'Filter',
  adminName: 'Name',
  adminEmail: 'Email',
  adminPlan: 'Plan',
  adminRole: 'Role',
  adminJoined: 'Joined',
  adminLastLogin: 'Last Login',
  adminStatus: 'Status',
  adminOwner: 'Owner',
  adminSeats: 'Seats',
  adminUsage: 'Usage',
  adminSubscription: 'Subscription',
  adminTarget: 'Target URL',
  adminUser: 'User',
  adminStarted: 'Started',
  adminDuration: 'Duration',
  adminOnline: 'Online',
  adminOffline: 'Offline',
  adminConfigured: 'Configured',
  adminNotConfigured: 'Not Configured',
  adminCollections: 'Collections:',
  adminStorage: 'Storage:',
  adminConnected: 'Connected',
  adminDisconnected: 'Disconnected',
  adminConnecting: 'Connecting',
  adminDisconnecting: 'Disconnecting',
  adminMs: 'ms',
  adminMB: 'MB',
  adminNoData: 'No data available',
  adminLoading: 'Loading...',
  adminFetchError: 'Failed to load data. Please try again.',
  adminFree: 'Free',
  adminLight: 'Light',
  adminBasic: 'Basic',
  adminPro: 'Pro',
  adminTrial1: 'Trial 1',
  adminTrial2: 'Trial 2',
  adminAllPlans: 'All Plans',
  adminAllStatuses: 'All Statuses',
  adminActive: 'Active',
  adminCanceled: 'Canceled',
  adminPastDue: 'Past Due',
  adminTrialing: 'Trialing',
  adminQueuedStatus: 'Queued',
  adminPendingStatus: 'Pending',
  adminCombiningStatus: 'Combining',
  adminCompletedStatus: 'Completed',
  adminFailedStatus: 'Failed',
  adminStoppedStatus: 'Stopped',
  adminPrevious: 'Previous',
  adminNext: 'Next',
  adminPaginationInfo: 'Page {page} of {pages} ({total} total)',
  adminWaiting: 'Waiting:',
  adminJobsActive: 'Active:',
  adminJobsFailed: 'Failed:',
  adminJobsCompleted: 'Completed:',
  adminRss: 'RSS',
  adminRetry: 'Retry',
  adminRefresh: 'Refresh',
  adminVerified: 'Verified',
  adminUnverified: 'Unverified',
  adminMember: 'Member',
  adminRoleAdmin: 'Admin',
  adminRoleSuperadmin: 'Super Admin',
  adminUptimeFormat: '{h}h {m}m {s}s',
  adminDurationSeconds: '{s}s',
  adminDurationMinutes: '{m}m {s}s',
  adminLastUpdated: 'Last updated: {time}',
  adminOnlineCount: '{online}/{total} Online',

  // ── Admin lifecycle actions ──────────────────────────────────────────────────
  adminActions: 'Actions',
  adminYou: 'You',
  adminDisabled: 'Disabled',
  adminEnable: 'Enable',
  adminDisable: 'Disable',
  adminMakeAdmin: 'Make Admin',
  adminRemoveAdmin: 'Remove Admin',
  adminRemoveFromOrg: 'Remove from Org',
  adminCancelSubscription: 'Cancel Subscription',
  adminActionFailed: 'Action failed. Please try again.',
  // ── Admin error codes (mapped in pages/Admin/adminLabels.js) ──────────────
  adminErrAccountDisabled: 'This account has been disabled. Please contact your administrator.',
  adminErrUnauthorized: 'Your session has expired. Please sign in again.',
  adminErrForbidden: 'You do not have permission to perform this action.',
  adminErrServer: 'Something went wrong on our side. Please try again.',
  adminErrSuperadminRequired: 'Only a super administrator can manage administrator accounts.',
  adminErrInvalidId: 'That record could not be identified.',
  adminErrUserNotFound: 'That user no longer exists.',
  adminErrOrgNotFound: 'That organization no longer exists.',
  adminErrInvalidRole: 'That role is not valid.',
  adminErrInvalidPayload: 'The request was not valid. Please try again.',
  adminErrSelfRole: 'You cannot change your own role.',
  adminErrSelfDisable: 'You cannot disable your own account.',
  adminErrSelfDelete: 'You cannot delete your own account.',
  adminErrLastAdmin: 'This is the last remaining administrator and cannot be removed.',
  adminErrLastAdminOrg: 'Disabling this organization would lock out the last remaining administrator.',
  // ── API error/status codes (mapped in utils/apiErrors.js) ─────────────────
  errUnexpected: 'Something went wrong. Please try again.',
  errSessionRevoked: 'Your password was changed, so this session has ended. Please sign in again.',
  errAuthResetTokenInvalid: 'This reset link is invalid or has expired. Please request a new one.',
  errTooManyRequests: 'Too many requests. Please wait a few minutes and try again.',
  errOrgCreating: 'Your organization is still being set up. Please wait a moment and try again.',
  errPlanCheckFailed: 'We could not verify your plan limits just now. Please try again.',
  errInsufficientRole: 'Only the organization owner or an admin can purchase or change a plan.',
  errAlreadySubscribed: 'You already have an active subscription. Cancel it before purchasing a different plan.',
  errNetwork: 'Network error. Please check your connection and try again.',
  errPasswordsMismatch: 'Those passwords do not match.',
  joinWelcome: 'Welcome to {orgName}! Redirecting…',
  joinInviteInvalidTitle: 'Invite Invalid',
  joinGoHome: 'Go to Homepage',
  errServer: 'Something went wrong on our side. Please try again.',
  errUnauthorized: 'Your session has expired. Please sign in again.',
  errForbidden: 'You do not have permission to do that.',
  errAccountDisabled: 'This account has been disabled. Please contact your administrator.',
  errAuthNoToken: 'Sign-in could not be completed. Please try again.',
  errAuthGoogleFailed: 'Google sign-in failed. Please try again.',
  errAuthGoogleSuccess: 'Signed in with Google.',
  errAuthNameRequired: 'Please enter your name.',
  errAuthEmailInvalid: 'Please enter a valid email address.',
  errAuthPasswordRequired: 'Please enter your password.',
  errAuthPasswordTooShort: 'Password must be at least 8 characters.',
  errAuthUserExists: 'An account with this email already exists.',
  errAuthRegistered: 'Account created.',
  errAuthInvalidCredentials: 'That email or password is not correct.',
  errAuthLoginSuccess: 'Signed in.',
  errAuthOtpSent: 'We sent a verification code to your email.',
  errAuthOtpFormat: 'Enter the 6-digit verification code.',
  errAuthOtpInvalid: 'That code is invalid or has expired.',
  errAuthResetEmailSent: 'If that email is registered, a reset link is on its way.',
  errAuthPasswordReset: 'Your password has been reset.',
  errOrgNotFound: 'That organization no longer exists.',
  errOrgNoMembership: 'You do not belong to an organization.',
  errOrgEmailRequired: 'Please enter an email address.',
  errOrgRoleInvalid: 'Please choose a valid role.',
  errOrgInviteForbidden: 'Only owners and admins can invite members.',
  errOrgInviteAdminForbidden: 'Only the owner can invite an admin.',
  errOrgInviteCancelForbidden: 'Only owners and admins can cancel invites.',
  errOrgInviteInvalid: 'This invite link is not valid. It may have already been used.',
  errOrgInviteUsed: 'This invite has already been accepted.',
  errOrgInviteExpired: 'This invite has expired. Ask your team admin for a new one.',
  errOrgInviteNotFound: 'That invite no longer exists.',
  errOrgInviteInactive: 'That invite is no longer active.',
  errOrgInviteCancelled: 'Invite cancelled.',
  errOrgInviteTokenRequired: 'This invite link is incomplete.',
  errOrgInviteEmailMismatch: 'This invite was sent to a different email address. Sign in with the invited address to accept it.',
  errOrgSeatLimit: 'This organization has no seats available. Upgrade the plan to add more members.',
  errOrgAlreadyMember: 'You are already a member of this organization.',
  errOrgOtherOrgMember: 'You already belong to a different organization. Contact support to transfer.',
  errOrgAccountExists: 'An account with this email already exists. Sign in to accept the invite.',
  errOrgSignupFieldsRequired: 'Please provide your name and a password to create an account.',
  // ── System-health service labels ──────────────────────────────────────────
  // Vendor names are intentional: this panel is internal operator tooling and
  // on-call staff need to know which service is down.
  adminHealthServer: 'Node.js Server',
  adminHealthMongodb: 'MongoDB',
  adminHealthRedis: 'Redis',
  adminHealthQueue: 'BullMQ Queue',
  adminHealthWebcheck: 'WebCheck',
  adminHealthZap: 'OWASP ZAP',
  adminHealthZapAuth: 'OWASP ZAP (Authenticated)',
  adminHealthGemini: 'Gemini AI',
  adminHealthPagespeed: 'Google PageSpeed',
  adminHealthUrlscan: 'urlscan.io',
  adminHealthUnreachable: 'Service unreachable — see the browser console for details.',
  adminErrNoOrg: 'That user does not belong to an organization.',
  adminErrOwnerProtected: 'Delete the organization instead of removing its owner.',
  adminErrNoSubscription: 'That organization has no active subscription.',

  adminUserDeleted: 'User deleted successfully',
  adminUserUpdated: 'User updated successfully',
  adminUserRemovedFromOrg: 'User removed from organization',
  adminOrgDeleted: 'Organization deleted successfully',
  adminOrgUpdated: 'Organization updated successfully',
  adminSubscriptionCanceled: 'Subscription will be canceled at the end of the billing period',

  adminDeleteUserTitle: 'Delete User',
  adminDeleteUserMessage: 'Are you sure you want to permanently delete {name}? This action cannot be undone.',
  adminDeleteUserConfirm: 'Delete User',
  adminDisableUserTitle: 'Disable User',
  adminDisableUserMessage: '{name} will be immediately blocked from signing in. You can re-enable this account at any time.',
  adminRemoveFromOrgTitle: 'Remove from Organization',
  adminRemoveFromOrgMessage: '{name} will be removed from their organization and become a standalone account.',
  adminGrantAdminTitle: 'Grant Admin Access',
  adminGrantAdminMessage: 'Grant platform administrator access to {name}? They will be able to view and manage the entire Admin Dashboard.',
  adminRevokeAdminTitle: 'Remove Admin Access',
  adminRevokeAdminMessage: "Remove platform administrator access from {name}? They will lose access to the Admin Dashboard.",

  adminDeleteOrgTitle: 'Delete Organization',
  adminDeleteOrgMessage: 'Are you sure you want to permanently delete {name}? Its members will be removed from the organization and any active subscription will be canceled. This action cannot be undone.',
  adminDeleteOrgConfirm: 'Delete Organization',
  adminDisableOrgTitle: 'Disable Organization',
  adminDisableOrgMessage: 'All members of {name} will be immediately blocked from signing in. You can re-enable this organization at any time.',
  adminCancelSubscriptionTitle: 'Cancel Subscription',
  adminCancelSubscriptionMessage: "{name}'s subscription will be canceled at the end of the current billing period. They will keep access until then.",
  adminCancelSubscriptionConfirm: 'Cancel Subscription',

  // ── Executive Analytics ───────────────────────────────────────────────────────
  adminAnalytics: 'Analytics',
  adminEstimatedValue: 'Estimated Recurring Value',
  adminEstimateBadge: 'Estimate',
  adminEstimatedValueExplain: "Calculated as the number of organizations with an active subscription on each plan, multiplied by that plan's published list price (monthly-equivalent). This is an estimate based on current plan assignments — it does not reflect discounts, proration, failed payments, or refunds, none of which are recorded in the database.",
  adminEstimatedValueTotal: 'Estimated Monthly Value',
  adminEstimatedValueByPlan: 'Estimated Value by Plan',
  adminUserGrowth: 'New User Registrations',
  adminUserGrowthExplain: 'Daily count of new user accounts created over the last 30 days, based on the account creation date.',
  adminOrgGrowth: 'New Organization Registrations',
  adminOrgGrowthExplain: 'Daily count of new organizations created over the last 30 days, based on the organization creation date.',
  adminLast30Days: 'Last 30 days',
  adminNewInPeriod: '{count} new in this period',
  adminSubscriptionHealth: 'Subscription Health',
  adminSubscriptionHealthExplain: 'Current count of organizations by subscription status. This is a snapshot of right now, not a historical trend — past status changes are not logged.',
  adminScanActivity: 'Scan Activity',
  adminScanActivityExplain: 'Daily scan volume for the last 7 days only — scan records are automatically deleted after 7 days, so a longer trend cannot be shown.',
  adminLast7Days: 'Last 7 days',
  adminScansThisWeek: '{count} scans in this period',
  adminTopOrgsByUsage: 'Top Organizations by Usage',
  adminTopOrgsByUsageExplain: 'Organizations ranked by scans used in the current billing cycle.',
  // Content reused on the landing page (formerly the standalone /about page)
  aboutFeaturesTitle: 'Key Features',
  aboutFeaturePerformanceTitle: 'Performance & Accessibility',
  aboutFeaturePerformanceDescription: 'Scores covering page speed, accessibility, and search-engine best practices.',
  aboutFeatureVulnerabilityTitle: 'Vulnerability Scanning',
  aboutFeatureVulnerabilityDescription: 'Active testing for security vulnerabilities, each with a severity level and remediation guidance.',
  aboutFeatureInfraTitle: 'Infrastructure Reconnaissance',
  aboutFeatureInfraDescription: 'A deep technical look at SSL/TLS configuration, DNS records, cookies, detected technologies, and more.',
  aboutFeatureAuthTitle: 'Authenticated Scanning',
  aboutFeatureAuthDescription: 'Scan pages that sit behind a login wall by securely supplying credentials. They are never stored and are handled only in-memory.',
  aboutFeatureAiTitle: 'AI-Powered Analysis',
  aboutFeatureAiDescription: 'A written summary that explains the overall security posture in plain language, generated after every check completes.',
  aboutFeatureReportsTitle: 'Downloadable Reports',
  aboutFeatureReportsDescription: 'Full results available as a bilingual PDF report or a structured JSON export.',
  aboutFeatureOngoingTitle: 'Built for Teams & Organizations',
  aboutFeatureOngoingDescription: 'Stay on top of your website’s security over time. Create a company account, bring your team on board, and run scans whenever you need them.',
  aboutHowItWorksTitle: 'How It Works',
  aboutStep1Title: 'Submit a URL',
  aboutStep1Description: 'Enter the website you want to assess, with optional login details for an authenticated scan.',
  aboutStep2Title: 'Automated Analysis Runs',
  aboutStep2Description: 'The scan proceeds in the background, so you are free to keep working while it runs.',
  aboutStep3Title: 'Results Are Compiled',
  aboutStep3Description: 'Scores, vulnerability findings, and infrastructure details are consolidated into a single results view.',
  aboutStep4Title: 'AI-Generated Report',
  aboutStep4Description: 'Everything is synthesized into a plain-language summary explaining what was found and why it matters.',
  aboutStep5Title: 'Download & Act',
  aboutStep5Description: 'Download the full report as a PDF or JSON file to review with your team or hand off to a developer.',
  aboutReportsTitle: 'Reports & Results',
  aboutReportsBody: 'Every scan produces a dashboard of score cards, a detailed vulnerability list, an infrastructure detail report, a page screenshot, and an AI-written summary. Past scans stay viewable for a limited retention window, and your account keeps a running total of all scans over time.',
  aboutFormatPdfTitle: 'PDF Report',
  aboutFormatPdfDescription: 'Available in both English and Japanese, containing the full score summary, the AI-written analysis, and the vulnerability list for your plan tier.',
  aboutFormatJsonTitle: 'JSON Export',
  aboutFormatJsonDescription: 'The complete structured scan data, for teams that want to feed results into their own tooling or keep a full technical record.',
  aboutPlansTitle: 'Plans & Pricing',
  aboutPlansSubtitle: 'Three subscription tiers billed monthly or annually, plus one-time trial options.',
  aboutOrAnnual: 'or {amount}/year',
  aboutTrialsTitle: 'One-Time Trials',
  aboutPaymentsTitle: 'Secure Payments',
  aboutPaymentsBody: 'Checkout is handled by Stripe, a widely used payment processor. FORTEXA never sees or stores your card details. Both subscription billing and one-time payments are supported, your plan activates automatically once payment is confirmed, and prices shown are tax-exclusive with Japan’s 10% consumption tax added at checkout.',

  // Marketing landing page (shown at "/" to signed-out visitors only)
  marketingHeroEyebrow: 'Website Security Assessment',
  marketingHeroTitle: "Know exactly where your website's security stands.",
  marketingHeroSubtitle: "FORTEXA runs a full assessment of your site's security, performance, and configuration, then turns the results into a clear report you can act on immediately. No security expertise required.",
  marketingValueTitle: 'Why Fortexa',
  marketingAiTitle: 'AI-Powered Security Analysis',
  marketingAiLead: 'Turn complex security scan results into a clear, actionable security report.',
  marketingAiBody: 'Our AI analyzes scan findings and helps transform technical security data into an easy-to-understand report with key risks, summaries, and recommendations.',
  marketingAiPrivacyTitle: 'Built with Privacy in Mind',
  marketingAiPrivacyIntro: 'Before security scan data is processed by AI, identifying information is scrubbed from the data sent for analysis.',
  marketingAiPrivacyItemTargetLead: 'Target information is sanitized.',
  marketingAiPrivacyItemTargetRest: ' Website URLs, hostnames, IP addresses, DNS information, and scan identifiers are redacted before primary AI analysis.',
  marketingAiPrivacyItemUserLead: 'User identity is protected.',
  marketingAiPrivacyItemUserRest: ' Account names and email addresses are removed from data used for AI analysis.',
  marketingAiPrivacyItemHeadersLead: 'HTTP header values are sanitized.',
  marketingAiPrivacyItemHeadersRest: ' Potentially identifying URLs, hostnames, IP addresses, cookies, and redirect information are removed while useful security-header information is preserved.',
  marketingAiPrivacyItemGuardrail: 'The application also has a leakage-detection mechanism for AI prompts.',
  marketingFinalCtaTitle: 'See Security Clearly. Powered by AI.',
  marketingFinalCtaSecondary: 'Get Started',
};

